import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { UserRole } from 'src/api';
import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { MaintenancePage } from 'src/pages/maintenance';
import type { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <MaintenancePage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const MAINTENANCE_ROUTE: RouteProps = {
  path: appRoutes.maintenance.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [UserRole.Guest],
};
